<template><v-main></v-main></template>

<script>
import axios from "axios";

export default {
  name: "notificationLink",

  created() {
    axios
      .patch(
        this.$store.state.endpoint +
          "/notification/read/" +
          this.$route.params.id
      )
      .then(response => {
        this.$router.push(response.data.link);
      })
      .catch(error => console.log(error));
  }
};
</script>
